import { of } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@legalzoom/questionnaire-answer-sdk";
import * as i2 from "@legalzoom/business-formation-sdk";
export class QuestionnaireAnswerService {
    constructor(sdkQuestionnaireAnswerService, trackJsErrorLogService) {
        this.sdkQuestionnaireAnswerService = sdkQuestionnaireAnswerService;
        this.trackJsErrorLogService = trackJsErrorLogService;
    }
    prepareGetUserAnswers(context, customerId, processingOrderId, productName) {
        const that = this;
        return {
            name: 'prepareGetUserAnswers questionnaire-answer.service ' + context.constructor.name,
            pre: () => {
                return that.sdkQuestionnaireAnswerService.getUserAnswers(customerId, processingOrderId);
            },
            post: (response) => {
                if (!!response) {
                    context.userAnswers = response;
                }
            },
            error: (error) => {
                console.log(error.message);
                this.trackJsErrorLogService.track(productName, 'questionnaire-answer.service' + context.constructor.name, error);
                return of(null);
            }
        };
    }
    prepareDeleteQuestionnaireAnswers(context, customerId, productName, successDeleteQuestionnaireAnswers) {
        const that = this;
        return {
            name: 'deleteQuestionnaireAnswers questionnaire-answer.service ' + context.constructor.name,
            pre: () => {
                if (!context.questionnaireStorage && !!context.userAnswers) {
                    console.log(context.userAnswers);
                    return that.sdkQuestionnaireAnswerService.deleteQuestionnaireAnswers(customerId, context.userAnswers);
                }
                return of(false);
            },
            post: (response) => {
                console.log('prepareDelete return');
                successDeleteQuestionnaireAnswers(response);
            },
            error: (error) => {
                console.log(error.message);
                this.trackJsErrorLogService.track(productName, 'questionnaire-answer.service' + context.constructor.name, error);
                return of(null);
            }
        };
    }
}
QuestionnaireAnswerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function QuestionnaireAnswerService_Factory() { return new QuestionnaireAnswerService(i0.ɵɵinject(i1.QuestionnaireAnswerService), i0.ɵɵinject(i2.TrackJsErrorLogService)); }, token: QuestionnaireAnswerService, providedIn: "root" });
